import {FC} from "react";
import {ITypeRadar} from "../../../types";
import {SidebarTab} from "../../Sidebar";
import {
  IClusterDataFromServer,
  ITehnologiesDataFromServer,
} from "../../../pages/Dashboard/Dashboard.type";
import {ChartView} from "../../../types/chartView";
import {SideBarContentMapDirection} from "./SideBarContentMapDirection";
import {SideBarContentMapClusters} from "./SideBarContentMapClusters";
import {SideBarContentMapTehnologie} from "./SideBarContentMapTehnologie";

interface IProps {
  idMoleculeActive: number;
  clusterIdOnTehnologie: number;
  dataDirection: any | undefined;
  typeRadar: ITypeRadar;
  activeTab: string;
  dataCluster: IClusterDataFromServer | undefined;
  cpuStep: number;
  dataTechnology?: ITehnologiesDataFromServer | undefined;
  handleCardClick: (id: number | string, name: string) => void;
  handleSecondStepCpu: (id: string) => void;
  sortOption: any;
  handleSortTitle: any;
  handleSort: any;
  titleCluster: string;
  colorTitle?: string;
  technologieId?: number | string | null;
  setChartView: (value: ChartView) => void;
  chartView: ChartView;
}

export const SideBarContentMap: FC<IProps> = ({
  idMoleculeActive,
  clusterIdOnTehnologie,
  dataDirection,
  typeRadar,
  activeTab,
  dataCluster,
  cpuStep,
  dataTechnology,
  handleCardClick,
  handleSecondStepCpu,
  sortOption,
  handleSortTitle,
  handleSort,
  titleCluster,
  colorTitle,
  technologieId,
  setChartView,
  chartView,
}) => {
  return (
    <>
      {activeTab === SidebarTab.Clusters ? (
        <SideBarContentMapDirection
          dataDirection={dataDirection}
          typeRadar={typeRadar}
          handleCardClick={handleCardClick}
          sortOption={sortOption}
          handleSortTitle={handleSortTitle}
          handleSort={handleSort}
          colorTitle={colorTitle}
        />
      ) : activeTab === SidebarTab.CPU && cpuStep === 1 ? (
        <SideBarContentMapClusters
          dataCluster={dataCluster}
          typeRadar={typeRadar}
          handleSecondStepCpu={handleSecondStepCpu}
          handleSortTitle={handleSortTitle}
          handleSort={handleSort}
          sortOption={sortOption}
          colorTitle={colorTitle}
          titleCluster={titleCluster}
          setChartView={setChartView}
          chartView={chartView}
        />
      ) : (
        <SideBarContentMapTehnologie
          dataTehnology={dataTechnology}
          dataCluster={dataCluster}
          typeRadar={typeRadar}
          idMoleculeActive={idMoleculeActive}
          colorTitle={colorTitle}
          technologieId={technologieId}
          clusterIdOnTehnologie={clusterIdOnTehnologie}
          setChartView={setChartView}
          chartView={chartView}
        />
      )}
    </>
  );
};
